import { Prop, Vue, Watch } from "vue-property-decorator";
import { RequestsStates } from "fs-pb-vue2/data/enums/requestsStates";
import { getModule } from "vuex-module-decorators";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";
import { ConfigStore } from "fs-pb-vue2/store/modules/config";
import { OperationsListVue } from "fs-pb-vue2/vueModels/history/OperationsListVue";
import { OperationsHistoryApi } from "fs-pb-vue2/services/api/OperationsHistoryApi";
import IOperationsHistoryService from "fs-pb-vue2/services/history/IOperationsHistoryService";
import { RequestParamsModel } from "fs-pb-vue2/models/statement/requestParamsModel";
import { container } from "@/inversify.config";
import { StatementItemModel } from "fs-pb-vue2/models/statement/statementItemModel";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import i18n from "@/i18n";
 
export class OperationsListVueGB extends OperationsListVue {

  get contractStatementService(): IOperationsHistoryService {
    return container.get<IOperationsHistoryService>(DiTokens.ContractStatementService);
  }  

  @Watch('periodEnumValue', { immediate: true })
  async periodEnumChanged(value: string | null): void {
    if (value) {
      switch (value) {
        case "all":
          this.months[0] = this.dateToStringFormat(this.model.minDate || new Date('2010-01-01'));
          this.months[1] = this.dateToStringFormat(this.model.maxDate || new Date());
          break;
        case "nearDates":
          this.months[0] = this.dateToStringFormat(new Date().setDate(new Date().getDate() - 1));
          this.months[1] = this.dateToStringFormat(new Date());
          break;
        case "week":
          this.months[0] = this.dateToStringFormat(new Date().setDate(new Date().getDate() - 7));
          this.months[1] = this.dateToStringFormat(new Date());
          break;
        case "month":
          this.months[0] = this.dateToStringFormat(new Date().setMonth(new Date().getMonth() - 1));
          this.months[1] = this.dateToStringFormat(new Date());
          break;
        case "halfYear":
          this.months[0] = this.dateToStringFormat(new Date().setMonth(new Date().getMonth() - 3));
          this.months[1] = this.dateToStringFormat(new Date());
          break;
        case "year":
          this.months[0] = this.dateToStringFormat(new Date().setFullYear(new Date().getFullYear() - 1));
          this.months[1] = this.dateToStringFormat(new Date());
          break;
      }
      this.model.operationsList = await this.getOpeationsList("");
    }
  }

  /** Ответ на событие изменения фильтра emit(filterChange) */
  // async filterValue(e: any) {
  //   if (e.category) {
  //     this.filter = e.category;
  //   } else if (e.status) {
  //     this.model.operationsList = await this.getOpeationsList(
  //       "",
  //       e.status,
  //       this.model.filterContractId
  //     );
  //   } else if (e.contract === null) {
  //     this.model.operationsList = await this.getOpeationsList(
  //       "",
  //       this.model.status,
  //       ''
  //     );      
  //   } else if (e.contract) {
  //     this.loading = true;
  //     const resp: any = await this.contractStatementService.getOperationsHistory(
  //       new RequestParamsModel({
  //         dateBegin: this.months[0],
  //         dateEnd: this.months[1],
  //         contractId: e.contract,
  //         take: 1000,
  //         searchText: '',
  //         sortType: 1,
  //         filter: this.model.status,
  //         rootCatalog: this.catalogStore.catalog,
  //         contractType: this.model.contractType
  //       })
  //     );
  //     if (resp.list) {
  //       this.model.operationsList = resp.list;
  //     }
  //     this.loading = false;
  //   }
  // }

  /** Изменение значения периода */
  changeMonthVal(e: any) {
    this.months = e.period;
    this.periodEnumValue = null;
  }

  dateToStringFormat(value: any): string {
    const date: Date = new Date(value);
    const year: any = date.getFullYear();
    const month: any = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const day: any = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${year}-${month}-${day}`;    
  }

  @Prop() currCurrency!: string;

  @Prop() statementTitle!: string;

  @Prop() costAnalyz!: boolean;

  @Prop() historyDBO!: boolean;

  goToAnalyz(): void {
    const contract: any = this.$route.params.contractId ?? null;
    const card: any = this.$route.params.cardId ?? null;
    if (contract) {
      if (card) {
        this.$router.push(`/costAnalyz/${contract}/${card}`);
        return;
      }
      this.$router.push(`/costAnalyz/${contract}/0`);
      return;
    } else if (this.$route.name === 'OperationsHistory') {
      this.$router.push('/costAnalyz/0/0');
    }
  }

  toggleChart(e: any) {
    this.isChartHidden = !e.isShow;
  }

  searchVal: string = '';

  /** Показывать линию или диграмму */
  isChartHidden: boolean = true;

  periodEnumValue: string | null = null;

  periodEnum: Array<any> = [
    {
      title: 'Период',
      value: null
    },
    {
      title: 'Все время',
      value: 'all'
    },
    {
      title: 'Вчера и сегодня',
      value: 'nearDates'
    },
    {
      title: 'Неделя',
      value: 'week'
    },
    {
      title: 'Месяц',
      value: 'month'
    },
    {
      title: 'Квартал',
      value: 'halfYear'
    }, 
    {
      title: 'Год',
      value: 'year'
    }
  ]

  async mounted() {
    await this.init();
    if (this.model)
      this.model.isPeriod = true;
    if (this.$route.query.operInfo && this.$route.query.operInfo.length > 0 && this.model.operationsList)
      this.showOperInfoDialog(this.model.operationsList.find((item:any) => item.ReferenceId == this.$route.query.operInfo));
    else
      this.$route.query.operInfo = '';
  }

  async showOperInfoDialog(operation: any) {
    this.modalLoading = true;
    this.operInfoDialog = true;
    this.$router.push({ path: this.$route.fullPath, query: { 'operInfo': operation.ReferenceId } });
    this.modalDetails = await this.dynamicService.getOperationDetails(
      operation
    );
    this.modalLoading = false;
  }

  getItemTitleDate(date: string) {
    const myDate: Date = new Date(date);
    const toDate: Date = new Date();
    const esterday: Date = new Date(Date.now()-86400000);
    const days = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'];
    const dayName: string = days[myDate.getDay()];
    if (myDate === toDate)
      return 'Сегодня';
    else if (myDate === esterday)
      return 'Вчера';
    else 
      return this.$options.filters.date(date, 'date') + ', ' + dayName;
  }

  dateClick(e: any): void {
    this.showPicker = e;
  }

  get operationsOveralllSum(): string {
    if (this.model.operationsList) {
      return this.$options.filters.sum(
        this.model.operationsList.reduce((acc, item) => {
          if (item.Sum < 0 && item.RequestState === RequestsStates.Executed) {
            acc += item.Sum;
          }
          return acc;
        }, 0), true, this.currCurrency);
    }
    return `0 ${this.currCurrency}`
  }

  /** Фильтрация массива операций (пока фильтр отсуствует) */
  get getFilteredArray(): Array<any> {
    if (this.model.operationsList && this.model.operationsList.length > 0) {
      let resArr: Array<StatementItemModel> = this.model.operationsList.filter(item =>
        this.operationsFilterCondition(item) && item.Category !== 'Справки'
      );
  
      // если costAnalyz true, фильтровать только операции с отрицательным Sum и в статусе исполнено
      if (this.costAnalyz) {
        resArr = resArr.filter(item => item.Sum < 0 && item.RequestState === RequestsStates.Executed);
      }
  
      if (this.searchVal.length > 0) {
        resArr = resArr.filter((item: StatementItemModel) => 
          item.Description.toUpperCase().includes(this.searchVal.toUpperCase()) || item.Category.toUpperCase().includes(this.searchVal.toUpperCase()));
      }
      const resObjArr: Array<any> = [];
      resArr.map((item: StatementItemModel) => {
        const searched: any = resObjArr.find((obj: any) => obj.date === item.Date);
        if (resObjArr.length === 0 || !searched) {
          resObjArr.push({
            date: item.Date,
            operations: [item]
          });
        } else if (searched) {
          searched.operations.push(item);
        }
      })
      resObjArr.sort((a, b) => {
        const dateA = new Date(a.date).getTime();
        const dateB = new Date(b.date).getTime();
        return dateB - dateA; 
      });
      return resObjArr;
    }
    return [];
  }
}